import { TEMPLATE_MODELS } from '~constants/templates';

export const DISPATCH_METHODS_CONFIG = {
  [TEMPLATE_MODELS.SUSHI]: {
    hasArrow: false,
    hideOnResponsive: false,
    hasIcon: true,
    hasExtraWord: false,
    showEnterAddress: false,
    showBothComponents: false
  },
  [TEMPLATE_MODELS.GENERIC]: {
    hasArrow: false,
    hideOnResponsive: true,
    hasIcon: false,
    hasExtraWord: false,
    showEnterAddress: true,
    showBothComponents: true
  },
  [TEMPLATE_MODELS.BURGERS]: {
    hasArrow: true,
    hideOnResponsive: true,
    hasIcon: false,
    hasExtraWord: true,
    showEnterAddress: true,
    showBothComponents: false
  }
};

export const DISPATCH_METHODS_ALIGNMENT = {
  [TEMPLATE_MODELS.SUSHI]: {
    className: 'row middle end'
  },
  [TEMPLATE_MODELS.GENERIC]: {
    className: 'row middle end center full-width'
  },
  [TEMPLATE_MODELS.BURGERS]: {
    className: 'row end center'
  }
};
